// layout/footer.ts — static site footer.

import { html, markGlyph } from '../util';
import { navigate } from '../router';

function renderFooterInner(): string {
  const year = new Date().getFullYear();
  return html`
    <div class="wrap">
      <div class="footer-col">
        <a class="brand" href="#/landing" data-nav="landing">
          ${{ __raw: markGlyph(38) }}
          <span class="d-flex flex-column" style="margin-top: 14px;">
            <span class="brand-name">The Bray Family Foundation</span>
            <span class="brand-sub">Est. 1995 · 501(c)(3)</span>
          </span>
        </a>
        <p class="t-body" style="max-width: 340px; margin-top: 20px; font-size: 15px;">
          A small, all-volunteer family foundation supporting community-rooted nonprofits in our region.
        </p>
      </div>
      <div class="footer-col">
        <h6>Apply</h6>
        <a data-nav="grant-info">How to apply</a>
        <a data-nav="grant-info">Eligibility</a>
        <a data-nav="grant-info">Documents</a>
        <a data-nav="grant-info">FAQ</a>
      </div>
      <div class="footer-col">
        <h6>The Foundation</h6>
        <a data-nav="about">About us</a>
        <a data-nav="public-grants">Recent grants</a>
        <a data-nav="about">Contact</a>
      </div>
      <div class="footer-col">
        <h6>Account</h6>
        <a data-nav="login">Log in</a>
        <a data-nav="signup">Create an account</a>
        <a data-nav="user-dashboard">Your dashboard</a>
      </div>
    </div>
    <div class="wrap footer-bottom">
      <div>© 1995 – ${year} · The Bray Family Foundation</div>
      <div>A registered 501(c)(3) nonprofit organization</div>
    </div>
  `;
}

export function mountFooter(rootId = 'site-footer'): void {
  const root = document.getElementById(rootId);
  if (!root) return;
  root.innerHTML = renderFooterInner();

  root.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    const navEl = target.closest('[data-nav]') as HTMLElement | null;
    if (navEl) {
      e.preventDefault();
      navigate(navEl.getAttribute('data-nav')!);
    }
  });
}
